export const materialReserveTypePrice = {
    "BASE": "Базовая",
    "LAST": "Последняя",
    "ACTUAL": "Фактическая"
}